"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deprecated = void 0;
/* eslint-disable no-console */
var alreadyWarned = {};
function deprecated(alternativeSignature) {
    return function decorateProperty(target, name, descriptor) {
        if (descriptor === void 0) { descriptor = {
            writable: true,
            enumerable: false,
            configurable: true,
        }; }
        var type = typeof target === 'string' ? target : target.constructor.name;
        var deprecatedSignature = "".concat(type, ".").concat(name);
        var logWarning = function () {
            if (!alreadyWarned[deprecatedSignature]) {
                alreadyWarned[deprecatedSignature] = true;
                console.warn("Usage of ".concat(deprecatedSignature, " is deprecated, use ").concat(alternativeSignature, " instead."));
            }
        };
        var deprecatedDescriptor = {
            enumerable: descriptor.enumerable,
            configurable: descriptor.configurable,
        };
        if (descriptor.get || descriptor.set) {
            if (descriptor.get) {
                deprecatedDescriptor.get = function get() {
                    logWarning();
                    return descriptor.get.call(this);
                };
            }
            if (descriptor.set) {
                deprecatedDescriptor.set = function set(value) {
                    logWarning();
                    return descriptor.set.call(this, value);
                };
            }
        }
        else {
            var propertyValue_1 = descriptor.value;
            deprecatedDescriptor.get = function get() {
                logWarning();
                return propertyValue_1;
            };
            if (descriptor.writable) {
                deprecatedDescriptor.set = function set(value) {
                    logWarning();
                    propertyValue_1 = value;
                };
            }
        }
        return deprecatedDescriptor;
    };
}
exports.deprecated = deprecated;
//# sourceMappingURL=data:application/json;base64,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